<template>
  <v-menu
    offset-y
    v-model="showMenu"
    close-on-click
    nudge-bottom="5"
  >
    <template v-slot:activator="{ on }">
      <component
        :is="objectLink && hasAnyPermission('GUEST_VIEW') ? 'router-link' : 'placeholder-component'"
        v-on="on"
        :to="objectLink"
        :target="openInNewTab ? '_blank' : '_self'"
        class="guest-name"
        :title="getLinkTitle(guestName)"
        @contextmenu.native.prevent.stop="openMenu"
      >
        {{ guestName }}
        <v-icon
          v-if="canOpenInStayin"
          class="more-icon"
          style="opacity: 0;"
          size="16"
          @click.prevent.stop="openInStayin"
          color="primary"
          :title="trans('general.openInStayin')"
        >mdi-open-in-new</v-icon>
      </component>
    </template>
    <open-in-stayin-menu @open-in-stayin="openInStayin" />
  </v-menu>
</template>

<script>
import {MainUtils} from '../utils/main-utils';
import {OpenInStayinUtils} from '@/utils/open-in-stayin-utils';
import {LocaleUtils} from '@/utils/locale-utils';
import ConfigReader from '@/lib/config-reader';
import OpenInStayinMenu from '@/components/OpenInStayinMenu';
import PlaceholderComponent from '@/components/PlaceholderComponent';

export default {
  name: 'GuestName',
  components: {
    OpenInStayinMenu,
    PlaceholderComponent
  },
  mixins: [
    MainUtils,
    OpenInStayinUtils,
    LocaleUtils
  ],
  props: {
    value: {
      required: true
    },
    openInNewTab: {
      default () {
        return true;
      }
    }
  },
  computed: {
    isObjectProvided() {
      return this.value != null && typeof this.value === 'object';
    },
    guestName() {
      if(this.isObjectProvided) {
        return this.value.guestName ?? this.value.fullName ?? (this.value.firstName + ' ' + this.value.lastName);
      } else {
        return this.value;
      }
    },
    guestId() {
      return this.isObjectProvided ? (this.value.guestId ?? this.value.id) : this.value;
    },
    objectLink() {
      if(this.guestId == null) {
        return null;
      }

      return {
        name: 'GuestDetails',
        params: {
          guestId: this.guestId
        }
      }
    }
  },
  methods: {
    openInStayin () {
      const stayinUrlGuestDetails = ConfigReader.value('stayinUrlGuestDetails');
      if (!stayinUrlGuestDetails) {
        return;
      }
      window.open(stayinUrlGuestDetails.replace('{guestId}', this.guestId), '_blank');
    }
  }
}
</script>

<style scoped>
.guest-name {
  display: inline-block;
}

.guest-name:hover .more-icon {
  opacity: 1 !important;
}
</style>
